import type { RouteRecordRaw } from 'vue-router'
import {
  feedbackRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'
import { getFirstAccessibleRouteFromStorage } from '@/utils/defaultRoute'

const feedbackRoutes: RouteRecordRaw[] = [
  {
    path: 'feedback',
    redirect: () => getFirstAccessibleRouteFromStorage(feedbackRouteCandidates),
    meta: { permission: toAnyPermission(feedbackRouteCandidates) },
    children: [
      {
        path: 'items',
        name: 'feedback-items',
        component: () => import('@/views/feedback/FeedbackList.vue'),
        meta: { title: '反馈列表', permission: 'feedback:item:view' }
      },
      {
        path: 'items/:id',
        name: 'feedback-detail',
        component: () => import('@/views/feedback/FeedbackDetail.vue'),
        meta: { title: '反馈详情', permission: 'feedback:item:view' }
      },
      {
        path: 'apps',
        name: 'feedback-apps',
        component: () => import('@/views/feedback/FeedbackAppList.vue'),
        meta: { title: '接入应用', permission: 'feedback:app:view' }
      },
      {
        path: 'apps/:appId/product-bindings',
        name: 'feedback-product-bindings',
        component: () => import('@/views/feedback/FeedbackProductBinding.vue'),
        meta: { title: '产品绑定规则', permission: 'feedback:app:view' }
      }
    ]
  }
]

export default feedbackRoutes
